// extracted by mini-css-extract-plugin
module.exports = {"resetStepNumber":"_1-LIxt7WFf51NYr0BX44Wc","done":"_1OvXtcRw-8aJSzFcCi55Y5","resetStepText":"_321GbELD9n-6Vv2iT-jFii"};